import "./App.css";
import Location from "../src/component/location";
import Footer from "../src/component/footer";
import AboutUs from "../src/component/aboutUs";
import SmartKeyHero from "../src/component/smartKeyHero";
import TopHeader from "../src/component/topHeader";
import SmartKeySection from "../src/component/smartKeySection";
import HowItWorks from "../src/component/howItWorks";
import Outcomes from "../src/component/outcomes";
import Plans from "../src/component/plans";
import Services from "../src/component/services";
import { Box } from "@mui/system";
import PrivacyPolicy from "./component/privacyPolicy";
const App = () => {
  return (
    <>
      <Box className="headerCarouselSection">
        <TopHeader />
        <SmartKeyHero />
      </Box>
      <SmartKeySection />
      <HowItWorks />
      <Outcomes />
      <Plans />
      <Services />
      <AboutUs />
      <PrivacyPolicy />
      <Location />
      {/* <Customer /> */}
      <Footer />
    </>
  );
};
export default App;
